import { render, staticRenderFns } from "./PostDocCp.vue?vue&type=template&id=dc4ac52c&scoped=true&"
import script from "./PostDocCp.vue?vue&type=script&lang=js&"
export * from "./PostDocCp.vue?vue&type=script&lang=js&"
import style0 from "./PostDocCp.vue?vue&type=style&index=0&id=dc4ac52c&prod&lang=css&"
import style1 from "./PostDocCp.vue?vue&type=style&index=1&id=dc4ac52c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc4ac52c",
  null
  
)

export default component.exports